import React from 'react';
import axios from 'axios';
import { commonNodeModules, commonModules } from '.';
import { find } from 'lodash';
import { useContext } from 'react';


const useUspsValidation = () => {
  const { bootbox } = commonNodeModules,
  
        {  useTranslateText, APICallManager, UserContext, config, storeContext } = commonModules,
                  context = useContext(UserContext);

  const { state: storeState, dispatch } = React.useContext(storeContext);
  const { translateText } = useTranslateText();

  const toTitleCase = (str) => {
    if (!str) return '';
    return str.toLowerCase().split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.substring(1)
    ).join(' ');
  };

  const checkUspsValidation = (addressData) => {
    
    const { addressInfo, routeToComponent, check_Priority_In_Use, fields,  from, VarCopy01 } = addressData || {};
    context.VarCopy01 = VarCopy01 || 'No';
    let fieldsVar = {};
    fieldsVar['alt_phonetp'] = fieldsVar['alt_phonetp'] ?? [];
    fieldsVar['alt_phonetp'][0] = fields['alt_phonetp1'] ? fields['alt_phonetp1'] :
      (addressInfo && addressInfo['alt_phonetp']) ? addressInfo['alt_phonetp'][0] : '';
    fieldsVar['alt_phonetp'][1] = fields['alt_phonetp2'] ? fields['alt_phonetp2'] :
      (addressInfo && addressInfo['alt_phonetp']) ? addressInfo['alt_phonetp'][1] : '';
    fieldsVar['alt_phonetp'][2] = fields['alt_phonetp3'] ? fields['alt_phonetp3'] :
      (addressInfo && addressInfo['alt_phonetp']) ? addressInfo['alt_phonetp'][2] : '';
    fieldsVar['alt_phonetp'][3] = fields['alt_phonetp4'] ? fields['alt_phonetp4'] :
      (addressInfo && addressInfo['alt_phonetp']) ? addressInfo['alt_phonetp'][3] : '';
    fieldsVar['alt_phonetp'][4] = fields['alt_phonetp5'] ? fields['alt_phonetp5'] :
      (addressInfo && addressInfo['alt_phonetp']) ? addressInfo['alt_phonetp'][4] : '';

    fieldsVar['Phone#'] = fields['isPhone#'] ? fields['Phone#'] : addressInfo && addressInfo['Phone#'] || '';
    fieldsVar['Phone#'] = fieldsVar['Phone#'] && fieldsVar['Phone#'].length > 0 ? fieldsVar['Phone#'].replace(/\D+/g, '') : '';
    if (fields['altphone1']) fields['altphone1'] = fields['altphone1'].replace(/\D+/g, '') || fields['altphone1'];
    if (fields['altphone2']) fields['altphone2'] = fields['altphone2'].replace(/\D+/g, '') || fields['altphone2'];
    if (fields['altphone3']) fields['altphone3'] = fields['altphone3'].replace(/\D+/g, '') || fields['altphone3'];
    if (fields['altphone4']) fields['altphone4'] = fields['altphone4'].replace(/\D+/g, '') || fields['altphone4'];
    if (fields['altphone5']) fields['altphone5'] = fields['altphone5'].replace(/\D+/g, '') || fields['altphone5'];


    fieldsVar['alt_phone#'] = [];
    fieldsVar['alt_phone#'][0] = '';
    fieldsVar['alt_phone#'][1] = '';
    fieldsVar['alt_phone#'][2] = '';
    fieldsVar['alt_phone#'][3] = '';
    fieldsVar['alt_phone#'][4] = '';
    if (fieldsVar['alt_phonetp'][0]) {
      fieldsVar['alt_phone#'][0] = fields['altphone1'] ? fields['altphone1'] : (addressInfo && addressInfo['alt_phone#']) ? addressInfo['alt_phone#'][0] : '';
    }
    if (fieldsVar['alt_phonetp'][1]) {
      fieldsVar['alt_phone#'][1] = fields['altphone2'] ? fields['altphone2'] : (addressInfo && addressInfo['alt_phone#']) ? addressInfo['alt_phone#'][1] : '';
    }
    if (fieldsVar['alt_phonetp'][2]) {
      fieldsVar['alt_phone#'][2] = fields['altphone3'] ? fields['altphone3'] : (addressInfo && addressInfo['alt_phone#']) ? addressInfo['alt_phone#'][2] : '';
    }
    if (fieldsVar['alt_phonetp'][3]) {
      fieldsVar['alt_phone#'][3] = fields['altphone4'] ? fields['altphone4'] : (addressInfo && addressInfo['alt_phone#']) ? addressInfo['alt_phone#'][3] : '';
    }
    if (fieldsVar['alt_phonetp'][4]) {
      fieldsVar['alt_phone#'][4] = fields['altphone5'] ? fields['altphone5'] : (addressInfo && addressInfo['alt_phone#']) ? addressInfo['alt_phone#'][4] : '';
    }

    fieldsVar.Addr_Type = fields['Addr_Type'] ? fields['Addr_Type'] : addressInfo['Addr_Type'];
    fieldsVar.Addr_Line1 = fields['Addr_Line1'] ? fields['Addr_Line1'] : addressInfo && addressInfo.Addr_Line1 || '';
    fieldsVar.Addr_Line2 = fields['Addr_Line2'] ? fields['Addr_Line2'] : addressInfo && addressInfo.Addr_Line2 || '';

    fieldsVar.City = fields['City'] ? fields['City'] : addressInfo && addressInfo['City'] || '';
    fieldsVar['Country'] = fields['Country'] ? fields['Country'] : addressInfo['Country'] || '';
    fieldsVar['Country#'] =  fields['Country#'] ? fields['Country#'] : addressInfo && addressInfo['Country#'] || fieldsVar['Country#'] || '';
    fieldsVar.County = fields['County'] ? fields['County'] : addressInfo && addressInfo['County'] ? addressInfo['County'] : fieldsVar.County || '';
    fieldsVar.Addr_Status = addressInfo && addressInfo['Addr_Status'] ? addressInfo['Addr_Status'] : 'A' ;

    fieldsVar['CellPhone#'] = fields['isCellPhone'] ? fields['CellPhone'] : addressInfo && addressInfo['cellphone#'] || '';
    fieldsVar['CellPhone#'] = fieldsVar['CellPhone#'] && fieldsVar['CellPhone#'].length > 0 ? fieldsVar['CellPhone#'].replace(/\D+/g, '') : '';
    fieldsVar['CellCarrier'] = fields['cellcarrier'] ? fields['cellcarrier'] : addressInfo && addressInfo['cellcarrier'] || '';
    fieldsVar['State'] = fields['State'] ? fields['State'] : addressInfo && addressInfo['State'] || '';
    fieldsVar['Verbal'] = fields['Verbal'] ? fields['Verbal'] : addressInfo && addressInfo['Verbal'] || '';

    fieldsVar['SubDivision'] = fields['SubDivision'] ? fields['SubDivision'] : addressInfo && addressInfo['SubDivision'] || '';
    fieldsVar['Zip'] = fields['Zip'] ? fields['Zip'] : addressInfo && addressInfo['Zip'] || '';
    fieldsVar['Zip'] = fieldsVar['Zip'].replace(/\D+/g, '');
    fieldsVar['ee_address_BUFFER'] = addressInfo && addressInfo.ee_address_BUFFER || addressInfo?.EE_Address[0]?.EE_address_BUFFER || '';
    let tempEffDate = fields['Effective_Date'] ? fields['Effective_Date'] : addressInfo && addressInfo['Effective_Date'] || '';
    if (tempEffDate === '') {
      tempEffDate = new Date();
    }
    tempEffDate = new Date(tempEffDate);
    fieldsVar['Effective_Date'] = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(tempEffDate);
    let RecordID = (addressInfo && addressInfo.ee_address_RECID || addressInfo?.EE_Address[0]?.EE_address_RECID || 0).toFixed(0);
    fieldsVar['ee_address_RECID'] = RecordID;
    fieldsVar['Employee#'] = addressInfo?.['Employee#'] ?? addressInfo?.Employees[0]['Employee#'] ?? '';
   
    const data = {
        mode: 'GWEEAddressValidate', module: 'eeaddress', action:'Validate',  app: 'hr',
        ee_address: fieldsVar, recid: RecordID, 
      };
      const obj = { url: config.baseUrl + config.addressInformationURL, context: context };
    
      APICallManager.postRaw(
        obj,
        data,
        async (res) => {
     const responseData = res.data; 
      if (responseData.error) {
        const errorDetail = responseData.error.message || "Address Not Found";
        bootbox.alert({
          title: translateText('Message'),
          message: `<div>${translateText('USPS Standards Check:')}<br/><b>${translateText(errorDetail)}</b><br/><br/>` +
                   `${translateText('Please verify the address is correct before continuing.')}</div>`,
          callback: () => {
          }
        });
        return;
      }

      const usps = responseData.address;
      if (!usps) {
        return check_Priority_In_Use({ ...context, routeToComponent, storeState, dispatch });
      }

      let streetLine = usps.streetAddress || '';
      let secondaryLine = usps.secondaryAddress || '';
      if (secondaryLine && streetLine.endsWith(secondaryLine)) {
        streetLine = streetLine.replace(secondaryLine, '').trim();
      }

      const validated = {
        addr1: toTitleCase(streetLine),
        addr2: toTitleCase(secondaryLine),
        city: toTitleCase(usps.city),
        state: (usps.state || '').toUpperCase(),
        zip: usps.ZIPCode || '',
        fullZip: `${usps.ZIPCode}${usps.ZIPPlus4 ? '-' + usps.ZIPPlus4 : ''}`
      };
        const correction = responseData.corrections?.find(c => c.text);


      const isDifferent = 
        addressInfo.Addr_Line1?.toUpperCase() !== streetLine.toUpperCase() ||
        addressInfo.Addr_Line2?.toUpperCase() !== secondaryLine.toUpperCase() ||
        addressInfo.City?.toUpperCase() !== usps.city?.toUpperCase() ||
        addressInfo.Zip?.substring(0, 5) !== usps.ZIPCode;

      if (isDifferent) {
        const typedStr = `${addressInfo.Addr_Line1} ${addressInfo.Addr_Line2 || ''}, ${addressInfo.City} ${addressInfo.State} ${addressInfo.Zip}`;
        const standardStr = `${validated.addr1} ${validated.addr2}, ${validated.city} ${validated.state} ${validated.fullZip}`;

        bootbox.confirm({
          title: translateText('Message'),
          message: `<div> ${translateText('The Address you provided does not comply with USPS Standards')}
            <ol style='margin-left:20px; font-size: 13px; list-style: none;'>
              <li><b>Typed:</b> ${typedStr}</li>
              <li><b>USPS Standard:</b> ${standardStr}</li>
            </ol>`,
          buttons: {
            confirm: { label: translateText('Use USPS'), className: 'btn primary_button w-unset' },
            cancel: { label: translateText('Continue'), className: 'btn primary_button' },
          },
          callback: (confirmed) => {
            if (confirmed) {
              applyUpdates(validated, addressInfo, fields, from);
            }
            setTimeout(() => {
              check_Priority_In_Use({ ...context, routeToComponent, storeState, dispatch });
            }, 300);
          }
        });
      } else if (correction){
        let alertMessage = `<div>${translateText('The address has been matched but may require review:')}<br/>`;
       if (correction) {
          alertMessage += `<p style="margin: 10px 0; color: #856404; background-color: #fff3cd; border: 1px solid #ffeeba; padding: 10px; border-radius: 4px;">
            <b>${translateText('Note:')}</b> ${translateText(correction.text)}
          </p>`;
        }
        const typedStr = `${addressInfo.Addr_Line1} ${addressInfo.Addr_Line2 || ''}, ${addressInfo.City} ${addressInfo.State} ${addressInfo.Zip}`;
        alertMessage += `<ol style='margin-left:20px; font-size: 13px; list-style: none;'>
            <li><b>${translateText('You Typed:')}</b> ${typedStr}</li>
          </ol>`;

        bootbox.confirm({
          title: translateText('Address Verification'),
          message: alertMessage,
          buttons: {
            confirm: { label: translateText('Continue'), className: 'btn primary_button w-unset' },
            cancel: { label: translateText('Back'), className: 'btn primary_button' },
          },
          callback: (confirmed) => {
            if (confirmed) {
              applyUpdates(validated, addressInfo, fields, from);
              setTimeout(() => {
                check_Priority_In_Use({ ...context, routeToComponent, storeState, dispatch });
              }, 300);
            } else {
              console.log("User chose to manually edit the address.");
            }
          }
        });
          return; 
      } else {
        check_Priority_In_Use({ ...context, routeToComponent, storeState, dispatch });
      }
    });
  };

  const applyUpdates = (validated, addressInfo, fields, from) => {
    const keys = {
      Addr_Line1: validated.addr1,
      Addr_Line2: validated.addr2,
      City: validated.city,
      State: validated.state,
      Zip: validated.zip
    };

    Object.keys(keys).forEach(key => {
      const val = keys[key];
      addressInfo[key] = val;
      if (fields) fields[key] = val;
      if (from === 'Enrollment' && Array.isArray(fields)) {
        const item = find(fields, { key });
        if (item) item.value = val;
      }
    });
  };

  return { checkUspsValidation };
};

export default useUspsValidation;